<app-modal #modal>

  <span title class="title">
    @switch(true){
    @case(showGlobalAreas){
    {{"AREAS"|translate}}
    }
    @case(showCompanies){
    <button type="button" class="btn btn-light btn-rounded" (click)="handleGoBack()">
      <i class="bi bi-chevron-left"></i>
    </button>
    @if(authService.user?.isUserHQ){
    {{"COMPANIES"|translate}}
    }@else{
    {{globalAreas()![selectedAreaIndex()!].description}}&nbsp;/&nbsp;{{"COMPANIES"|translate}}
    }
    }
    @case(showStrap && authService.user?.isUserGenerallyHQ){
    <button type="button" class="btn btn-light btn-rounded" (click)="handleGoBack()">
      <i class="bi bi-chevron-left"></i>
    </button>
    {{selectedAreaCompaniesWithStrap()![selectedCompanyIndex()!]?.name}}&nbsp;/&nbsp;{{strap()?.stock?.sapcode}}
    }
    @case(showStoreStock){
    <button type="button" class="btn btn-light btn-rounded" (click)="handleGoBack()">
      <i class="bi bi-chevron-left"></i>
    </button>
    {{storeStock()?.storeName}}&nbsp;{{storeStock()?.store}}
    }
    @default {
    {{strap()?.stock?.sapcode}}
    }
    }
  </span>

  <div body class="strap-detail placeholder-glow" [class.company-list]="showCompanies">
    @switch (true) {

    @case (showStrap) {
    <div class="detail-row">
      <span class="field-name">{{"Creation Stock Details"|translate}}</span>
      <span class="value">{{strap()?.description}}</span>
    </div>
    <div class="detail-row">
      <span class="title">{{strap()?.details}}</span>
    </div>
    <div class="stock-wrapper">
      @if(showNoStorePlaceholder){

      <app-placeholder [message]="'No stock Available'|translate"></app-placeholder>

      }@else{
      @if(strap()?.prices && strap()!.prices!.length > 0){
      <div class="stock-row">
        <span class="title">
          {{"PRICELIST"|translate}}
        </span>
        <!-- <button class="btn btn-link" (click)="showPriceList()">View</button> -->
        <button #accordionButton class="pricelist-btn btn btn-link collapsed" type="button" data-bs-toggle="collapse"
          aria-expanded="false" [attr.aria-controls]="'collapse-prices'" appAccordion>
          <span>{{'View'|translate}}</span>
          <span>{{'Hide'|translate}}</span>
        </button>
        <div [id]="'collapse-prices'" class="accordion-collapse collapse">
          <div class="accordion-body">
            @for(price of strap()!.prices; track $index){
            <div class="price-row">
              <div>{{price.priceList}}</div>
              <div>
                {{sharedService.getPriceLabel(price)}}

                @if(price.tax){
                <div class="taxes">{{('Including Taxes'|translate)}}</div>
                }@else {
                <div class="taxes">{{('Excluding Taxes'|translate)}}</div>
                }
              </div>
            </div>
            }
            <div class="price-row">
              <button class="pricelist-btn btn btn-link collapsed" type="button" (click)="accordionButton.click()">
                <span>{{'Hide Pricelist'|translate}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      }
      <div class="stock-row ">
        <span class="title">{{"STORES"|translate}}</span>
      </div>
      <div class="stores placeholder-glow">

        @for(store of strap()!.stock.storeStocks; track store.idStore){

        <div class="stock-button">
          <div class="info">
            <span class="store">
              {{store.storeName}}&nbsp;-&nbsp;{{store.store}}
            </span>
            <!-- <span class="price">
              {{sharedService.getPriceLabel(price())}}
            </span> -->
          </div>
          <div class="stock">
            {{"Free"|translate}}&nbsp;<span class="counter">{{store.mainStock.free}}</span>
          </div>
          <button class="btn" (click)="selectStore(store)">
            <i class="bi bi-chevron-right"></i>
          </button>
        </div>

        }
      </div>
      }
    </div>
    }

    @case (showStoreStock){
    <div class="detail-row">
      <span class="field-name">{{"Creation Stock Details"|translate}}</span>
      <span class="value">{{strap()?.description}}</span>
    </div>
    <div class="detail-row">
      <span class="title">{{strap()?.details}}</span>
    </div>
    <div class="stock-wrapper">
      <div class="stock-row">
        <span class="title">{{"MORE DETAILS"|translate}}</span>
      </div>
      <div class="my-store-stock-wrapper">
        <app-my-store-stock [storeStock]="storeStock"></app-my-store-stock>
      </div>
    </div>
    }

    @case(showGlobalAreas){
    <div class="areas-wrapper">
      @for(area of globalAreas(); let i = $index; track $index) {
      <button class="btn btn-secondary area" (click)="selectArea(i)">
        <span>{{area.description}}</span>
        <span>
          <!-- @if(area.countCompanies > 0){
                  ({{area.countCompanies}})
                  } -->
          <i class="bi bi-chevron-right"></i>
        </span>
      </button>
      }
    </div>
    }

    @case(showCompanies){
    <div class="areas-wrapper">
      @for(company of selectedAreaCompaniesWithStrap(); let i = $index; track $index) {
      <app-stock-button [text]="company?.name" [counters]="company?.stockCounters || _EMPTY_STOCK_COUNTERS"
        [placeholder]="company?.strap === undefined" (handleClick)="selectCompany(i)" [strapView]="true">
      </app-stock-button>
      }
    </div>
    }

    }
  </div>

  <div footer class="footer">

  </div>

</app-modal>

<app-price-list-modal #priceListModal></app-price-list-modal>
